module.exports = __webpack_public_path__ + "static/img/2.727b15af.jpg";